import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=c29b9518&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=c29b9518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29b9518",
  null
  
)

export default component.exports